import { createStore } from 'redux';

export default createStore(
  (
    state = { sidebarShow: 'responsive' },
    { type, ...rest },
  ) => (type === 'set' ? { ...state, ...rest } : state),
);
